import React, { useEffect, useState } from "react";
import { Box, Grid, Heading } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getMoviesData } from "../Redux/action";
import MovieCard from "../Components/MovieCard";

const WatchList = () => {
  const movies = useSelector((store) => store.movies);
  const dispatch = useDispatch();
  const [deletionCount, setDeletionCount] = useState(0);

  useEffect(() => {
    dispatch(getMoviesData());
  }, [dispatch, deletionCount]);

  const handleMovieUpdate = () => {
    setDeletionCount((prev) => prev + 1);
  };

  return (
    <Box>
      <Heading
        color={"black.600"} mt={5} mb={5}
        fontSize={{ base: "1.2rem", sm: "2rem", md: "2.2rem" }}
      >
        Watchlist
      </Heading>
      <Box w={"95%"} margin={"auto"}>
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(4, 1fr)",
          }}
          gap={4}
        >
          {Array.isArray(movies) &&
            movies
              .filter((movie) => movie.watchStatus)
              .map((movie) => (
                <MovieCard
                  key={movie._id}
                  movie={movie}
                  onDelete={handleMovieUpdate}
                />
              ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WatchList;
